const PLACEHOLDER_DESCRIPTION = /\b(e2e|placeholder|lorem ipsum|tbd|todo|xxx)\b/i;

export function entitlementPublishError(
  description: string | undefined,
  ownerIds: string[] | undefined,
): string | null {
  const text = (description || '').trim();
  if (text.length < 12 || PLACEHOLDER_DESCRIPTION.test(text)) {
    return 'Enter a real description. Placeholder text cannot be saved.';
  }
  const owners = (ownerIds || []).map((id) => String(id || '').trim()).filter(Boolean);
  if (owners.length === 0) {
    return 'An entitlement needs an owner before it can be saved.';
  }
  return null;
}

export function requestApprovalPreview(input: {
  name?: string;
  ownerNames: string[];
  primaryNames: string[];
  secondaryNames: string[];
  memberNames: string[];
  memberCount?: number;
  ownerApproval: boolean;
  securityApproval: boolean;
}): string {
  const owners = input.ownerNames.length > 0 ? input.ownerNames.join(', ') : 'no owner yet';
  const steps = [
    input.ownerApproval ? `the owner (${owners})` : null,
    input.primaryNames.length > 0 ? input.primaryNames.join(', ') : null,
    input.secondaryNames.length > 0 ? input.secondaryNames.join(', ') : null,
    input.securityApproval ? 'security' : null,
  ].filter((step): step is string => Boolean(step));
  const path = steps.length > 0 ? steps.join(', then ') : 'no extra approver';
  const members = input.memberNames.length > 0
    ? input.memberNames.join(', ')
    : (input.memberCount || 0) > 0
      ? `${input.memberCount} people`
      : 'nobody yet';
  return `A request for ${input.name || 'this entitlement'} would be approved by ${path}. People who already have it: ${members}.`;
}
